import Switcher from '../switcher/switcher';

class ValueSlider extends Switcher {
  uiCollections = {
    togglers: '[data-switcher-toggler]',
    contents: '[data-switcher-content]',
    bars: '[data-switcher-bar]',
  };

  onInit() {
    super.onInit();

    this.startInterval();
    this.playSlider();
  }

  startInterval = () => {
    this.interval = setInterval(this.playSlider, 5000);
  };

  playSlider = () => {
    const { togglers } = this.uiCollections;

    const currentTogglerIndex = togglers.findIndex((t) => t.classList.contains(this.switcherItemActiveClassName));

    const nextTogglerIndex = (currentTogglerIndex !== togglers.length - 1) ? currentTogglerIndex + 1 : 0;

    this.uiCollections.togglers.forEach((togglerEl) => {
      togglerEl.classList.remove(this.switcherItemActiveClassName);
    });
    togglers[nextTogglerIndex].classList.add(this.switcherItemActiveClassName);

    this.uiCollections.contents.forEach((contentEl) => {
      contentEl.classList.remove(this.switcherContentActiveClassName);

      if (contentEl.dataset.switcherContent === togglers[nextTogglerIndex].dataset.switcherToggler) {
        contentEl.classList.add(this.switcherContentActiveClassName);
      }
    });
  };

  handleTabClick = (event) => {
    event.preventDefault();

    if (this.interval) {
      clearInterval(this.interval);
    }

    const { bars } = this.uiCollections;

    bars.forEach((bar) => bar.classList.add('value-slider-card__bar_hide'));

    const togglerEl = event.currentTarget;

    if (togglerEl.classList.contains(this.switcherItemActiveClassName)) {
      return;
    }

    this.uiCollections.togglers.forEach((togglerEl) => {
      togglerEl.classList.remove(this.switcherItemActiveClassName);
    });
    togglerEl.classList.add(this.switcherItemActiveClassName);

    this.uiCollections.contents.forEach((contentEl) => {
      contentEl.classList.remove(this.switcherContentActiveClassName);

      if (contentEl.dataset.switcherContent === togglerEl.dataset.switcherToggler) {
        contentEl.classList.add(this.switcherContentActiveClassName);
      }
    });
  };
}

export default ValueSlider;
